import { default as apiConfing } from "../config.json";

export enum LocationFilterType {
  Country = 1,
  MyArea,
  MyCity,
}

export enum DoubleMatchType {
  NoAction = 1,
  SentMessage,
  DoubleMatch,
  OtherSentMessage,
  Rejected,
}

export enum RegistrationType {
  EMAIL_PASSWORD = 1,
  GOOGLE = 3,
  APPLE = 4,
  FACEBOOK = 5,
}

export enum BounakirFilterType {
  SENT_THEM_BOUNAKIR = 1,
  SENT_ME_BOUNAKIR,
  DOUBLE_MATCH,
  WATCHE_ME,
  BOUNAKIR_NEMU,
}

export enum MessageType {
  Text = 1,
  Image,
  Video,
  Audio,
  Location,
  ProfileImages,
  BreakTheIce,
}

export enum HomeScreenType {
  NONE = 0,
  HOME,
  CONVERSTAION,
  BOUNAKIR,
  BOUNAKIR_WATCH_ME,
  BOUNKIR_LINKS,
  MY_PROFILE,
}

export enum HomeCarpetFilterCategory {
  AVAILABLE_NOW = 1,
  PREMIUM = 2,
  IN_MY_MOOD = 3,
  CLOSE_TO_ME = 4,
  TAG = 5,
  ORDER_BY_NEW = 6,
  VERIFIED_MEMBERS = 7,
  LAST_SEEN_ONLINE = 8,
  ORDER_BY_SIMILAR_TAGS = 9,
}

export enum ConversationFilterCategory {
  NONE,
}

export enum GenderType {
  MALE = 5,
  FEMALE = 15,
}

export enum SignupQuestionType {
  EMAIL = 3,
  PASSWORD,
  NICKNAME,
  BIRTHDAY,
  LOCATION,
  PERSONAL_STATUS = 15,
}

export enum AppLanguages {
  HEB = 1,
  ENG = 2,
}

export enum NotRelevantTag {
  //development = tag equal 34, production tag equal=1177
  // NOT_RELEVANT = apiConfing.IS_DEVELOPMENT ? 34 : 1177,
  NOT_RELEVANT = apiConfing.IS_DEVELOPMENT ? 1177 : 1177,
}

export enum QuestionIds {
  ABOUT_ME_QUESTION = apiConfing.IS_DEVELOPMENT ? 13 : 13,
  INTEREST_QUESTION = apiConfing.IS_DEVELOPMENT ? 21 : 2036,
}

export enum GAEventNames {
  REGISTRATION = "new signing",
  SEND_BOUNAKIR = "new send bounakir",
  ACCEPTED_BOUNAKIR = "new accepted bounakir",
  VISITED_PREMIUM_PAGE_AD = "new visitor on premium page ad",
  CLICKED_ON_SHOW_ME_PREMIUM_OFFERS = "new clicked show me premium offers",
  CLICKED_ON_UPGRADE_TO_PREMIUM = "new clicked on upgrade to premium",
  APP_ENGAGMENT = "app_engagment",
  APP_ACTIONS = "app_actions",
  APP_PURCHASE = "app_purchase",
  APP_SIGNUP = "app_signup",
}

export enum GACategoryName {
  NAME = "sign up",
  BOUNAKIR = "bounakir",
  PREMIUM = "premium",
  DATING_SCREEN = "dating_screen",
  COMMUNITY_SCREEN = "community_screen",
  ACCOUNT_SETTING = "account_setting",
  PROFILE_ENGAGMENT = "profile_engagment",
  FILTER_USAGE = "filter_usage",
  PREMIUM_SCREEN = "premium_screen",
  SOCIAL_SCREEN = "social_screen",
  PROFILE_ACTIONS = "profile_actions",
  PREMIUM_SERVICE = "premium_service",
  SIGNING_STEPS = "signing_steps",
}

export enum GAActions {
  REGISTRATION = "signing",
  SEND_BOUNAKIR = "send bounakir",
  ACCEPTED_BOUNAKIR = "accepted bounakir",
  VISITED_PREMIUM_PAGE_AD = "visited premium page ad",
  CLICKED_ON_SHOW_ME_PREMIUM_OFFERS = "clicked show me premium offers",
  CLICKED_ON_UPGRADE_TO_PREMIUM = "clicked on upgrade to premium",
  CLICK = "click",
  CHAT = "chat",
  PROFILE_FREEZE = "profile freeze",
  PROFILE_DELETE = "profile delete",
}

export enum GAUniqueEventIds {
  REGISTRATION = 1,
  SEND_BOUNAKIR,
  ACCEPTED_BOUNAKIR,
  VISITED_PREMIUM_PAGE_AD,
  CLICKED_ON_SHOW_ME_PREMIUM_OFFERS,
  CLICKED_ON_UPGRADE_TO_PREMIUM,
  APP_ENGAGMENT,
  APP_ACTIONS,
  APP_SIGNUP,
}

export enum PageContentText {
  PREMIUM_SALE_TITLE_ID = 1,
}

export enum SubscriptionPlans {
  ONE_MONTH = 1,
  THREE_MONTH,
  SIX_MONTH,
  LIGHT,
}
